import { useEffect, useState } from "react";
import { STATIC } from "@/data/content";

export const Preloader = ({ onDone }) => {
  const [mounted, setMounted] = useState(!STATIC);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (STATIC) {
      onDone?.();
      return;
    }
    const t1 = setTimeout(() => setLeaving(true), 1900);
    const t2 = setTimeout(() => {
      setMounted(false);
      onDone?.();
    }, 2700);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [onDone]);

  if (!mounted) return null;

  return (
    <div
      data-testid="preloader"
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0a0a0a] transition-transform duration-[900ms] ease-[cubic-bezier(0.76,0,0.24,1)] ${
        leaving ? "-translate-y-full" : "translate-y-0"
      }`}
    >
      <div className="overflow-hidden">
        <p className="font-mono-accent animate-[pl-up_0.7s_cubic-bezier(0.22,1,0.36,1)_both] text-xs uppercase tracking-[0.4em] text-yellow-400">
          Growth Therapy
        </p>
      </div>

      <div className="mt-6 overflow-hidden">
        <h2 className="font-display animate-[pl-up_0.8s_0.15s_cubic-bezier(0.22,1,0.36,1)_both] text-4xl uppercase text-white sm:text-6xl">
          Performance, cured.
        </h2>
      </div>

      <div className="mt-10 h-[2px] w-[260px] overflow-hidden">
        <div className="h-full w-full origin-left animate-[pl-line_1.4s_0.3s_cubic-bezier(0.76,0,0.24,1)_both] bg-yellow-400" />
      </div>
    </div>
  );
};
